import { Typography } from 'ck-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { getStoreLocation } from 'ck-utils';

const storeLocation = getStoreLocation();

const TermsAndPrivacyLinks = ({ noSMS }) => {
  const content = noSMS ? 'By signing up, you agree to our '
    : `By submitting this form and signing up for texts,
      you consent to receive marketing text messages
      (e.g. promos, cart reminders) from Culture Kings at the number provided, including messages sent by autodialer.
      Consent is not a condition of purchase. ${storeLocation !== 'NZ' ? 'Msg & data rates may apply.' : ''} Msg frequency varies.
      Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available). `;
  return (
    <Typography align="centered" display="block" variant="body-small" className="mt-3">
      {content}
      <Typography renderAs="a" variant="body-small" underline href="/pages/privacy-policy">
        Privacy Policy
      </Typography>
      <span> & </span>
      <Typography renderAs="a" variant="body-small" underline href="/pages/terms-of-use">
        Terms.
      </Typography>
    </Typography>
  );
};

TermsAndPrivacyLinks.propTypes = {
  noSMS: PropTypes.bool,
};

TermsAndPrivacyLinks.defaultProps = {
  noSMS: false
};

export { TermsAndPrivacyLinks };
